'use client'

import { usePathname } from 'next/navigation'

/** An in-page anchor that becomes `/#section` away from the homepage. */
export function SectionLink({
  href,
  label,
  className,
}: {
  readonly href: string
  readonly label: string
  readonly className?: string
}) {
  const pathname = usePathname()
  const onHomepage = pathname === '/' || pathname === null
  const resolved = href.startsWith('#') && !onHomepage ? `/${href}` : href
  return (
    <a href={resolved} className={className}>
      {label}
    </a>
  )
}
